import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const DocumentIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={0}
    fill="currentColor"
    stroke="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.18934 2.68934C4.47064 2.40804 4.85217 2.25 5.25 2.25h9c.1989 0 .3897.07902.5303.21967l5.25 5.25c.1407.14065.2197.33142.2197.53033v12c0 .3978-.158.7794-.4393 1.0607s-.6629.4393-1.0607.4393H5.25c-.39782 0-.77935-.158-1.06066-.4393-.2813-.2813-.43934-.6629-.43934-1.0607V3.75c0-.39783.15804-.77936.43934-1.06066ZM13.9393 3.75H5.25v16.5h13.5V8.56066L13.9393 3.75Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.25 2.25c.4142 0 .75.33579.75.75v4.5h4.5c.4142 0 .75.33579.75.75s-.3358.75-.75.75h-5.25c-.4142 0-.75-.33579-.75-.75V3c0-.41421.3358-.75.75-.75Z"
      fill="currentColor"
      stroke="none"
    />
  </SvgIcon>
);

export default DocumentIcon;
